import { SET_KIOSK_SYNC_CART } from './constants';
import { SET_HANDOFF as SWITCH_HANDOFF_TOGGLE } from '../register/payment/constants';
import { HANDOFF_RESET_KIOSK_CART, HANDOFF_SUCCESS } from '../handoff/constants';

/**
 * @description
 * This reducer stores an instance of cart that web commander sends to the iPad app in kiosk mode for itemized breakdown
 * We don't and shouldn't reuse this cart instance for other purposes
 */
const kioskSyncCart = (state = null, { type, payload }) => {
  switch (type) {
    case SET_KIOSK_SYNC_CART:
      return payload;
    case HANDOFF_SUCCESS:
    case SWITCH_HANDOFF_TOGGLE:
    case HANDOFF_RESET_KIOSK_CART:
      return null;
    default:
      return state;
  }
};

export default kioskSyncCart;

